import {LngLatBounds, MapBoundsLocation} from '@logistics-frontend/blocks'
import {useEffect, useRef} from 'react'

import {MapModes} from '../../types'

type MapBoundsRef = {
  mode: MapModes
  bounds: LngLatBounds
}

export const useBoundsByMode = (bounds: MapBoundsLocation | undefined, mode: MapModes) => {
  const boundsRef = useRef<MapBoundsRef>()

  useEffect(() => {
    // Меняем bounds только когда пришел новый mode
    if ((!boundsRef.current || boundsRef.current.mode !== mode) && bounds) {
      boundsRef.current = {bounds: bounds.bounds, mode}
    }
  }, [mode, bounds])

  return boundsRef.current?.bounds
}
